import React from 'react';
import { Input } from './Input';
import { Select } from './Select';
import type { SelectOption } from './Select';
import { Button } from './Button';

interface DashboardFilterField {
  key: string;
  type: 'search' | 'select';
  label: string;
  placeholder?: string;
  options?: SelectOption[];
}

interface DashboardFilterProps {
  fields: DashboardFilterField[];
  values: Record<string, string | number>;
  onChange: (key: string, value: string | number) => void;
  onApply?: () => void;
  onReset?: () => void;
  loading?: boolean;
}

export const DashboardFilter: React.FC<DashboardFilterProps> = ({
  fields,
  values,
  onChange,
  onApply,
  onReset,
  loading = false,
}) => {
  return (
    <div className="rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 p-6 shadow-sm mb-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
        {fields.map((field) => (
          <div key={field.key}>
            {field.type === 'search' ? (
              <Input
                label={field.label}
                placeholder={field.placeholder}
                value={values[field.key] || ''}
                onChange={(e) => onChange(field.key, e.target.value)}
                disabled={loading}
                fullWidth
              />
            ) : (
              <Select
                label={field.label}
                options={field.options || []}
                value={values[field.key] || ''}
                onChange={(e) => onChange(field.key, e.target.value)}
                disabled={loading}
                fullWidth
              />
            )}
          </div>
        ))}
      </div>
      <div className="flex gap-2 justify-end">
        {onReset && (
          <Button
            variant="outline"
            size="md"
            onClick={onReset}
            disabled={loading}
          >
            Reset
          </Button>
        )}
        {onApply && (
          <Button
            variant="primary"
            size="md"
            onClick={onApply}
            isLoading={loading}
          >
            Apply Filters
          </Button>
        )}
      </div>
    </div>
  );
};

export default DashboardFilter;
